import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage, {FORM_STATE_INIT_ERROR} from '../../components/plain/PlainPage';
import TabbedPane from '../../components/plain/TabbedPane';
import Label from '../../components/plain/Label';
import FieldCheckBox from '../../components/plain/FieldCheckBox';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldDate from '../../components/plain/FieldDate';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldString from '../../components/plain/FieldString';
import FieldReference from '../../components/plain/FieldReference';
import FieldRefList from '../../components/plain/FieldRefList';
import FieldObject from '../../components/plain/FieldObject';
import FieldList_Reference from '../../components/plain/FieldList_Reference';
import FieldList_TableGroup from '../../components/plain/FieldList_TableGroup';
import ModalDialog from '../../components/modal/ModalDialog';
import ButtonSelectInstance from '../../modal/selectinstance/ButtonSelectInstance';
import DivOrganization, {validateOrganization} from './components/DivOrganization';
import { Instance } from '../../util/realm/instance';


import {getLanguage, isUserSuperUser,getUserInfo} from '../../util/localStorage';
import {getDefinedValue} from '../../util/tools';
import {ENUMERATION_BOOKSHOP_TYPE, ENUMERATION_OBJECT_STATUS, ENUMERATION_PREMISES, 
} from '../../util/consts/common';
import {CLASS_PROVIDER, CLASS_ORGANIZATION, CLASS_AUTHORITY_PUBLISHER, CLASS_BOOKSHOP } from '../../util/consts/classes';
import {FORM_PROVIDER_PLAIN, FORM_ORGANIZATION_TABLE, FORM_AUTHORITY_PUBLISHER_TABLE,
} from '../../util/consts/forms';
import {ORGANIZATION_PLAIN_PATH, AUTHORITY_PUBLISHER_PLAIN_PATH, BOOKSHOP_PLAIN_PATH} from '../../util/routes';
import {performApiRequest, performApiRequestForm, ACTION_BOOKSHOP_GET_PROVIDER_BOOKSHOP_API_URL, 
	ACTION_BOOKSHOP_GET_PROVIDER_BOOKSHOP_FULL_API_URL, ENTITY_SAVE_API_URL, 
	ENTITY_LOAD_LIST_API_URL, ACTION_EBOOK_MERCHANT_LOAD_LIST_API_URL,
} from '../../util/restapi'; 

import iconAdd from '../../assets/icons/png24x24/Add.png';
import iconInsert from '../../assets/icons/png24x24/insert.png';
import iconCheckMark from '../../assets/icons/png24x24/check_mark.png';
import iconDelete from '../../assets/icons/png24x24/Delete.png';

const selectMerchantRvContext = {
	rateView: null,
	form: 'ebook_merchant_table',
	formTitle: 'Мерчант', 
	data: null
}
const selectTerminalRvContext = {
	rateView: null,
	form: 'ebook_terminal_table',
	formTitle: 'Термінал', 
	data: null
}

class ProviderPlainPage extends PlainPage {
	
	enumBookShopType = null;
	enumObjectStatus = null;
	enumPremises = null;

	listBookShopRef = [];
	
	constructor(props) {
		super(props);
		this.formPath = FORM_PROVIDER_PLAIN;
		this.formTitle = 'Постачальник';
		this.buildInstanceCard = this.buildProviderCard;
		this.refBookShopPlainModalDialog = React.createRef();
		this.state.listBookShop = [];
	}
	componentDidMount = async () => {
		this.init( CLASS_PROVIDER );
		document.title = 'BOM. ' + this.formTitle;
	}
	async completeInit() {
		this.enumBookShopType = this.realm.getEnumeration( ENUMERATION_BOOKSHOP_TYPE );
		this.enumObjectStatus = this.realm.getEnumeration( ENUMERATION_OBJECT_STATUS );
		this.enumPremises = this.realm.getEnumeration( ENUMERATION_PREMISES );

		let request = {providerId: this.instance.id};
		let response = await performApiRequest(
			ACTION_BOOKSHOP_GET_PROVIDER_BOOKSHOP_API_URL, request);
		if( ! response.success ) {
			this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
			return false;
		} 
		this.listBookShopRef = response.listBookShop;

		response = await performApiRequest(
			ACTION_BOOKSHOP_GET_PROVIDER_BOOKSHOP_FULL_API_URL, request);
		if( ! response.success ) {
			this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
			return false;
		}
		this.setState({listBookShop: response.listBookShop});

		return true;
	}
	
	openBookshopModal = () => {
		this.refBookShopPlainModalDialog.current.prepareOpen();
		this.refBookShopPlainModalDialog.current.openModal();
	}
	addBookshop = () => {
		let response = this.refBookShopPlainModalDialog.current.taskResponse;
		if( response && response.success ) {
			let data = JSON.parse( response.data );
			let list = [...this.state.listBookShop];
			list.push( data.entity );
			this.setState({listBookShop: list});
		}
	}
	
	buildProviderCard = (providerInstance) => {
		let card = '';
		let currentLanguage = getLanguage();
		let name = null;
		for(let n of providerInstance.rootField.value.organization.value.names.value) {
			if( n.value.language.value == currentLanguage && n.value.name.value ) {
				name = n;
				break;
			}
		}
		if( name == null && providerInstance.rootField.value.organization.value.names.value.length > 0)
			name = providerInstance.rootField.value.organization.value.names.value[0];
		if( name != null ) {
			if( name.value.name.value )
				card += name.value.name.value;
			else if( name.value.shortName.value )
				card += name.value.shortName.value;
		} 
		return card;
	}
	
	validateInstance() {
		return validateOrganization(this.instance, this.instance.rootField.value.organization);
	}

	createTab = (tabId) => {
		let instance = this.state.instance;
		let fieldGroup = instance.rootField;
		let readOnly = this.instanceReadOnly;
		if( tabId == 'brands' )
			return (
				<div style={{display: 'flex', alignItems: 'center', padding: '10px'}}>
					<FieldList_Reference instance={instance} path={'brands'} plain={this} parentField={fieldGroup} 
						readOnly={true} disableAddItems={true} disableMoveItems={true} disableDeleteItems={true}
						ignoreTitle={true}
						refNodes = {[
							{
								classId: CLASS_AUTHORITY_PUBLISHER, plainFormPath: AUTHORITY_PUBLISHER_PLAIN_PATH, 
								selectInstanceFormId: FORM_AUTHORITY_PUBLISHER_TABLE,
								selectInstanceFormTitle: 'Бренди'
							},
						]}
						styles={{divMain: {flexGrow: '1'}, table: {width: '100%'}}}
					/>
				</div>
			);
		if( tabId == 'merchants' )
			return (
				<div style={{padding: '10px'}}>
					<MerchantList instance={instance} path={'/merchantList'} plain={this} parentField={fieldGroup}
						plainDirtyCounter={this.state.plainDirtyCounter}
						readOnly={readOnly} disableMoveItems={true} ignoreTitle={true}
						createHeaderCellComponent={this.createMerchantHeaderCell}
						createDataCellComponent={this.createMerchantDataCellComponent}
						table={{
							columns: [
								{ columnId: 'status', styles: {tdHeader: {width: '15%'} } }, 
								{ columnId: 'bookShopRef', styles: {tdHeader: {width: '35%'} } },
								{ columnId: 'acquirerRef', styles: {tdHeader: {width: '20%'} } },
								{ columnId: 'mid', styles: {tdHeader: {width: '20%'} } },
								{ columnId: 'mcc', styles: {tdHeader: {width: '15%'} } },
								{ columnId: 'ebook', styles: {tdHeader: {width: '5%'}} },
							],
						}}
						styles={{
							table: {width: '100%'},
							trHeader: {height: '40px'}
						}}
					/>
				</div>
			);
		if( tabId == 'terminals' )
			return (
				<div style={{padding: '10px'}}>
					<TerminalList instance={instance} path={'/terminalList'} plain={this} parentField={fieldGroup}
						plainDirtyCounter={this.state.plainDirtyCounter}
						readOnly={readOnly} disableMoveItems={true} ignoreTitle={true}
						createDataCellComponent={this.createTerminalDataCellComponent}
						table={{
							columns: [
								{ columnId: 'status', styles: {tdHeader: {width: '15%'} } }, 
								{ columnId: 'bookShopRef', styles: {tdHeader: {width: '35%'} } },
								{ columnId: 'acquirerRef', styles: {tdHeader: {width: '20%'} } },
								{ columnId: 'tid', styles: {tdHeader: {width: '15%'} } },
								{ columnId: 'comments', styles: {tdHeader: {width: '15%'} } },
							],
						}}
						styles={{
							table: {width: '100%'},
							trHeader: {height: '40px'}
						}}
					/>
				</div>
			);
		if( tabId == 'bookshops' ) {
			let buttonAddDisabled = ! (this.instance.id);
			let rowsHtml = this.state.listBookShop.map( (bookshop, index) => {
				let url = BOOKSHOP_PLAIN_PATH + '/' + bookshop.id;
				return (
					<tr key={index}>
						<td>{ this.realm.getEnumerationItemText( this.enumBookShopType, bookshop.type) }</td>
						<td>{ this.realm.getEnumerationItemText( this.enumObjectStatus, bookshop.status) }</td>
						<td><a href={url} target='_blank'>{bookshop.localCode}</a></td>
						<td><a href={url} target='_blank'>{bookshop.name}</a></td>
						<td>{bookshop.city}</td>
						<td>{bookshop.place}</td>
						<td>{ this.realm.getEnumerationItemText( this.enumPremises, bookshop.premises) }</td>
						<td>{bookshop.totalArea}</td>
						<td>{bookshop.shoppingArea}</td>
					</tr>
				)
			} );
			return (
				<div style={{padding: '10px'}}>
					<div style={{marginBottom: '10px'}}>
						<button type='button' className={stylesPlain.buttonIcon} style={{}}
							onClick={this.openBookshopModal} disabled={buttonAddDisabled} title={'Додати книгарню'}
						>
							<img src={iconAdd} />
						</button>
					</div>
					<table border='1'>
						<thead style={{fontWeight: 'bold'}}>
							<tr>
								<td>Тип</td>
								<td>Статус</td>
								<td>Код</td>
								<td>Назва</td>
								<td>Місто</td>
								<td>Місце</td>
								<td>Статус приміщення</td>
								<td>Загальна площа</td>
								<td>Торгівельна площа</td>
							</tr>
						</thead>
						<tbody>
							{rowsHtml}
						</tbody>
					</table>
				</div>
			);
		}
		return <div>Unknown tabId: {tabId}</div>;
	}


	createMerchantHeaderCell = (columnId) => {
		if( columnId == 'ebook' ) {
			let labelStyle = {color: 'black', fontWeight: 'bold', fontStyle: 'normal'}; 
			return (<Label title={'єКнига'} tooltip={'Позначка, чи приймає мерчант участь в програмі єКнига'} styles={{ divMain: labelStyle}} />);
		} else 
			return null;
	}
	createMerchantDataCellComponent = (columnId, rowIndex, instance, itemField, plain, plainDirtyCounter) => {
		let readOnly = this.instanceReadOnly;
		let idReadOnly = ( readOnly || itemField.ref.id ) ? true : false;
		idReadOnly = idReadOnly && ! isUserSuperUser(); 		
		if( columnId == 'acquirerRef' ) {
			return(
				<FieldRefList path={'acquirerRef'} instance={instance} plain={plain} readOnly={idReadOnly} 
					parentField={itemField} classId={'EBookBank'} styles={{}}
					ignoreTitle={true} 
				/>
			)
		}
		if( columnId == 'bookShopRef' ) {
			return (
				<FieldRefList path={'bookShopRef'} instance={instance} plain={plain} readOnly={readOnly} 
					parentField={itemField} explicitList={this.listBookShopRef} styles={{}}
					ignoreTitle={true} 
				/>
			);
		} else if( columnId == 'ebook' ) {
			let showMark = itemField.value.eBookParticipant.value == 1;
			if( showMark ) {
				return (<div style={{textAlign: 'center'}}><img src={iconCheckMark} /></div>);
			} else
				return (<div>&nbsp;</div>);
		} else if( columnId == 'mid' ) {
			return (
				<FieldString instance={instance} path={'mid'} plain={plain} readOnly={idReadOnly} 
					parentField={itemField} ignoreTitle={true} styles={{ input: {width: 'calc(100% - 10px)'}}} 
				/>
			);
		}
		return null;
	}	
	createTerminalDataCellComponent = (columnId, rowIndex, instance, itemField, plain, plainDirtyCounter) => {
		let readOnly = this.instanceReadOnly;
		let idReadOnly = ( this.instanceReadOnly || itemField.ref.id ) ? true : false;		
		idReadOnly = idReadOnly && ! isUserSuperUser(); 		
		if( columnId == 'acquirerRef' ) {
			return(
				<FieldRefList path={'acquirerRef'} instance={instance} plain={plain} readOnly={idReadOnly} 
					parentField={itemField} classId={'EBookBank'} styles={{}}
					ignoreTitle={true} 
				/>
			)
		} 
		if( columnId == 'bookShopRef' ) {
			return (
				<FieldRefList path={'bookShopRef'} instance={instance} plain={plain} readOnly={readOnly} 
					parentField={itemField} explicitList={this.listBookShopRef} styles={{}}
					ignoreTitle={true} 
				/>
			);
		}
		if( columnId == 'tid' ) {
			return (
				<FieldString instance={instance} path={'tid'} plain={plain} readOnly={idReadOnly} 
					parentField={itemField} ignoreTitle={true} styles={{ input: {width: 'calc(100% - 10px)'}}} 
				/>
			);
		}
		return null;
	}	
	
	renderBody() {
		let instance = this.state.instance;
		let fieldGroup = instance.rootField;
		let readOnly = this.instanceReadOnly;
		let fieldOrganization = instance.rootField.value.organization;
		
		let tabs = [
			{
				rowId: 'first',
				tabs: [
					{ tabId: 'brands', tabTitle: 'Бренди', }, 
					{ tabId: 'merchants', tabTitle: 'Мерчант-рахунки', }, 
					{ tabId: 'terminals', tabTitle: 'Термінали', },
					{ tabId: 'bookshops', tabTitle: 'Книгарні', },
				]
			},
		];
		
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldCheckBox instance={instance} path={'publisher'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ divMain: {marginRight: '20px'} }}
						/>
						<FieldCheckBox instance={instance} path={'printer'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ divMain: {marginRight: '20px'} }}
						/>
						<FieldCheckBox instance={instance} path={'seller'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ divMain: {marginRight: '20px'} }}
						/>
						<FieldCheckBox instance={instance} path={'aggregator'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ divMain: {marginRight: '100px'} }}
						/>
						<FieldEnum instance={instance} path={'providerState'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
						/>
						
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'certSeries'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ input: {width: '100px', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'certNumber'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ input: {width: '100px', marginRight: '20px'} }}
						/>
						<FieldDate instance={instance} path={'certDate'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ input: {width: '200px', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'comment'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'} }}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldReference instance={instance} path={'mainOrgRef'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							refNodes = {[
								{
									classId: CLASS_ORGANIZATION, plainFormPath: ORGANIZATION_PLAIN_PATH, 
									selectInstanceFormId: FORM_ORGANIZATION_TABLE,
									selectInstanceFormTitle: 'Організації'
								}
								
							]}
							styles={{ divMain: {flexGrow: '1'} }}
						/>
					</div>
				
					<div style={{padding: '5px', border: '1px solid blue', marginBottom: '20px'}}>
						<div style={{marginBottom: '15px'}}>
							<FieldObject instance={instance} path={'organization'} plain={this} parentField={fieldGroup} 
								readOnly={readOnly}
								refNodes = {[
									{
										classId: CLASS_ORGANIZATION, plainFormPath: ORGANIZATION_PLAIN_PATH, 
										selectInstanceFormId: FORM_ORGANIZATION_TABLE,
										selectInstanceFormTitle: 'Організації'
									},
								]}
								styles={{label: {divMain: {marginRight: '10px', fontWeight: 'bold'}}}}
							/>
						</div>
						<DivOrganization instance={instance} fieldGroup={fieldOrganization} readOnly={readOnly} plain={this}/>
					</div>
					<TabbedPane tabs={tabs} createTab={this.createTab} 
						styles={{ divMain: {border: '1px solid gray', marginBottom: '15px'} }} 
					/>

				</div>
				<BookShopPlainModalDialog ref={this.refBookShopPlainModalDialog} plainMaster={this}
					doAfterClose={this.addBookshop} 
				/>

			</div>
		)
	}
}

class MerchantList extends FieldList_TableGroup {
	
	onMerchantSelected = async (ids) => {
		if( ids.length == 0 )
			return;
		console.log("ids", ids);
		let response = await performApiRequest( ACTION_EBOOK_MERCHANT_LOAD_LIST_API_URL, {listId: ids} );
		if( ! response.success ) {
			this.props.plain.app.showResponse( response );
			return;
		}
		console.log("listMerchant", response);
			
		let instance = this.props.instance;
		let fieldMerchants = instance.rootField.value.merchantList;
		let itemModel = fieldMerchants.model.item;
		for( let m of response.data ) {
			let item = instance.createObjectField( itemModel, m );
			instance.addListItem(fieldMerchants, item);
		}
	}
	
	createHeaderHtml() {
		
		let labelEmptyHtml = null;
		let divHeaderStyle = {display: 'flex', alignItems: 'center', marginBottom: '5px', width: '100%'};
		let readOnly = getDefinedValue( this.props.readOnly, false);
		let buttonDeleteDisabled = readOnly || ! isUserSuperUser();
		let headerHtml = (
			<div style={divHeaderStyle}>
				{this.createTitleHtml()}
				{labelEmptyHtml}
				<div style={{display: 'flex'}}>
					{this.createButtonAddHtml()}
					<ButtonSelectInstance
						tooltip={'Під\'єднати існуючого мерчанта'} icon={iconInsert}
						selectInstanceRvContext={selectMerchantRvContext} 
						onInstanceSelected={this.onMerchantSelected}
						disabled={readOnly}
						style={{width: '36px', height: '30px', marginLeft: '4px'}}
					/>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.deleteItem} disabled={buttonDeleteDisabled} title={'Вилучити'}
					>
						<img src={iconDelete} />
					</button>
				</div>
			</div>
		);
		return headerHtml;
	}
}

class TerminalList extends FieldList_TableGroup {
	
	onTerminalSelected = async (ids) => {
		if( ids.length == 0 )
			return;
		console.log("ids", ids);
		let response = await performApiRequest( ENTITY_LOAD_LIST_API_URL, {listId: ids} );
		if( ! response.success ) {
			this.props.plain.app.showResponse( response );
			return;
		}
		console.log("listTerminal", response);
			
		let instance = this.props.instance;
		let fieldTerminals = instance.rootField.value.terminalList;
		let itemModel = fieldTerminals.model.item;
		for( let m of response.data ) {
			let item = instance.createObjectField( itemModel, m );
			instance.addListItem(fieldTerminals, item);
		}
	}

	createHeaderHtml() {
		let labelEmptyHtml = null;
		let divHeaderStyle = {display: 'flex', alignItems: 'center', marginBottom: '5px', width: '100%'};
		let readOnly = getDefinedValue( this.props.readOnly, false);
		let buttonDeleteDisabled = readOnly || ! isUserSuperUser();
		let headerHtml = (
			<div style={divHeaderStyle}>
				{this.createTitleHtml()}
				{labelEmptyHtml}
				<div style={{display: 'flex'}}>
					{this.createButtonAddHtml()}
					<ButtonSelectInstance
						tooltip={'Під\'єднати існуючий термінал'} icon={iconInsert}
						selectInstanceRvContext={selectTerminalRvContext} 
						onInstanceSelected={this.onTerminalSelected}
						disabled={readOnly}
						style={{width: '36px', height: '30px', marginLeft: '4px'}}
					/>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.deleteItem} disabled={buttonDeleteDisabled} title={'Вилучити'}
					>
						<img src={iconDelete} />
					</button>
				</div>
			</div>
		);
		return headerHtml;
	}
}

class BookShopPlainModalDialog extends ModalDialog {
	
	/*
		plainMaster
	*/
	constructor(props) {
		super(props);
		this.maxWidth = '800px';
		this.title='Книгарня';
		this.state = {instance: null};
		this.showTryAgainButtonErrorOnly = true;
	}
	prepareOpen() {
		if( ! this.realm )
			this.realm = this.props.plainMaster.realm;
		if( ! this.instanceModel )
			this.instanceModel = this.realm.getInstanceModel(CLASS_BOOKSHOP);
		let instance = new Instance(this.instanceModel);
		this.setState({instance: instance})
	}
	async performRequest() {
		let bean = this.state.instance.createBean();
		bean.providerRef = this.props.plainMaster.instance.getRef();
		bean.feVersion = 'plain1';
		console.log('Save bean', bean);
		let jsonInstance = JSON.stringify( bean );
		
		const form = new FormData();
		form.append('jsonInstance', jsonInstance);
		form.append('class', this.state.instance.model.entityId);
		let response = await performApiRequestForm(ENTITY_SAVE_API_URL, form);
		return response;
	}
	
	renderForm() {
		let plain = this.props.plainMaster;
		let instance = this.state.instance;
		return (
			<div style={{margin: '10px 20px 0 20px', padding: '10px'}}>
				<div style={{display: 'flex', alignItems: 'center', marginTop: '20px' }}>
					<FieldString instance={instance} path={'/name'} plain={plain}
						styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
					 />
					<FieldString instance={instance} path={'/localCode'} plain={plain}
						styles={{ input: {width: '50px', marginRight: '20px'} }}
					 />
					<FieldEnum instance={instance} path={'/type'} plain={plain} 
						styles={{ select: {flexGrow: '0', marginRight: '20px'}}} 
					/>
					<FieldEnum instance={instance} path={'/status'} plain={plain} 
						styles={{ select: {flexGrow: '0'}}} 
					/>
				</div>			
				<div style={{display: 'flex', alignItems: 'center', marginTop: '20px' }}>
					<FieldString instance={instance} path={'/city'} plain={plain}
						styles={{ input: {width: '280px', marginRight: '20px'} }}
					 />
					<FieldString instance={instance} path={'/place'} plain={plain}
						styles={{ input: {flexGrow: '1'} }}
					 />
				</div>			
				<div style={{display: 'flex', alignItems: 'center', marginTop: '20px' }}>
					<FieldEnum instance={instance} path={'/premises'} plain={plain} 
						styles={{ select: {width: '200px', marginRight: '20px'}}} 
					/>
					<FieldDecimal instance={instance} path={'/totalArea'} plain={plain}
						styleInput={{width: '60px', textAlign: 'right', marginRight: '20px'}} 
					/>
					<FieldDecimal instance={instance} path={'/shoppingArea'} plain={plain}
						styleInput={{width: '60px', textAlign: 'right'}} 
					/>
				</div>
			</div>
		)
	}
}


export default ProviderPlainPage;
